module.exports = __webpack_public_path__ + "assets/jboss.efe9773f.svg";